module.exports = __webpack_public_path__ + "img/ico-add-alt.107f14ac.svg";